// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import { get, post } from './api';
import { ENDPOINTS } from '../utils/constants';
import type { HitlApproval, HitlDecision, HitlDecisionRequest } from '../types';

export interface ListApprovalsFilters {
  siteId?: string;
  approvalType?: string;
}

/**
 * List HITL approvals, optionally filtered by site and approval type.
 * Filtering happens BFF-side (the BFF fetches all approvals from HITL and
 * filters them, since HITL's own list endpoint has no filter parameters).
 */
export const listApprovals = (filters: ListApprovalsFilters = {}): Promise<HitlApproval[]> => {
  const params = new URLSearchParams();
  if (filters.siteId) params.set('site_id', filters.siteId);
  if (filters.approvalType) params.set('approval_type', filters.approvalType);
  const qs = params.toString();
  return get<HitlApproval[]>(qs ? `${ENDPOINTS.HITL_APPROVALS}?${qs}` : ENDPOINTS.HITL_APPROVALS);
};

/** Submit an approve/reject decision for a pending review. */
export const submitReviewDecision = (
  reviewId: string,
  decision: HitlDecisionRequest
): Promise<HitlDecision> => post<HitlDecision>(ENDPOINTS.HITL_REVIEW_DECISIONS(reviewId), decision);
